import React, { type FC, useMemo, useContext } from 'react';

import { useIsEmbeddedConfluence_DO_NOT_USE } from '@confluence/embedded-confluence-check';
import { isMobileApp_DO_NOT_USE } from '@confluence/mobile-app-detection-common';

import { BannerContext } from './BannerContext.tsx';

export const BannerContextProvider: FC<{
	includeTopNav?: boolean;
	suppressed?: boolean;
	children: React.ReactNode;
}> = ({ includeTopNav, suppressed, children }) => {
	const { includeTopNav: inheritedOrDefaultValue, suppressed: inheritedSuppressed } =
		useContext(BannerContext);
	const isEmbeddedConfluence = useIsEmbeddedConfluence_DO_NOT_USE();
	const isMobileApp = isMobileApp_DO_NOT_USE();
	if (typeof includeTopNav !== 'boolean') {
		includeTopNav = isEmbeddedConfluence || isMobileApp ? false : inheritedOrDefaultValue;
	}
	// Suppression is inherited so a nested provider cannot accidentally un-suppress a subtree.
	const resolvedSuppressed = suppressed === true || inheritedSuppressed === true;
	const bannerContextValue = useMemo(
		() => ({ includeTopNav, suppressed: resolvedSuppressed }),
		[includeTopNav, resolvedSuppressed],
	);
	return <BannerContext.Provider value={bannerContextValue}>{children}</BannerContext.Provider>;
};
